export const HeaderBandMaxSize = {
    WIDTH: 150,
    HEIGHT: 400,
};
export const HeaderBandMinSize = {
    WIDTH: 90,
    HEIGHT: 340,
};

export const HeaderSliderMaxHeight = 340;
export const HeaderSliderMinHeight = 180;

export const ColorOrder = [
    "red",
    "blue",
    "yellow",
    "green",
    "orange",
    "violet",
    "teal"
];
